var $16c853acb10a3d18$exports = {};
$16c853acb10a3d18$exports = {
    "actions": `\u{52D5}\u{4F5C}`,
    "hideButtonLabel": `\u{986F}\u{793A}\u{8F03}\u{5C11}`,
    "noTags": `\u{7121}`,
    "showAllButtonLabel": (args, formatter)=>`\u{986F}\u{793A}\u{5168}\u{90E8} (${formatter.number(args.tagCount)})`
};


export {$16c853acb10a3d18$exports as default};
//# sourceMappingURL=zh-TW.mjs.map
